"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRelativeLuminance = getRelativeLuminance;
/**
 * Calculates the relative luminance of a color according to WCAG 2.0.
 *
 * Relative luminance represents the relative brightness of any point in a colorspace,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * @param color The color to analyze.
 * @returns A number between 0 (darkest black) and 1 (lightest white) representing the relative luminance.
 */
function getRelativeLuminance(color) {
    var rgb = color.toRgb();
    var _a = [rgb.r, rgb.g, rgb.b].map(function (channel) {
        var c = channel / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    }), r = _a[0], g = _a[1], b = _a[2];
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
